/* eslint-disable */

/////////////////////////////////////////////
////// Functions to manipulate cookies //////
/////////////////////////////////////////////
// cookie setter
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
 }
 
 // cookie getter
 function getCookie(cname) {
   var name = cname + "=";
   var ca = document.cookie.split(';');
   for(var i = 0; i < ca.length; i++) {
     var c = ca[i];
     while (c.charAt(0) == ' ') {
       c = c.substring(1);
     }
     if (c.indexOf(name) == 0) {
       return c.substring(name.length, c.length);
     }
   }
   return "";
 }
 
 function debounce(func, wait, immediate) {
   let timeout;
   return function() {
     const context = this;
     const args = arguments;
     const later = () => {
       timeout = null;
       if (!immediate) func.apply(context, args);
     };
     const callNow = immediate && !timeout;
     clearTimeout(timeout);
     timeout = setTimeout(later, wait);
     if (callNow) func.apply(context, args);
   };
 }

export default {
  init() {
    // JavaScript to be fired on the Signup page

    ///////////////
    // FUNCTIONS //
    ///////////////

    // function to adjust the height of the Signup form progress dots container to match the Free Shipping CTA header
    function equalizeSignupHeaderHeight() {
      const freeShippingRowHeight = $('#free-shipping-cta-row').height();
      console.log('freeShippingRowHeight: ', freeShippingRowHeight);
      $('#signup-progress-row, #signup-progress-container').css({"height":`${freeShippingRowHeight}px`});
    }

    // function for initializing the slider and dots for the Signup process
    function initializeSlider(container_id, slider_options) {
      $(`#${container_id}`).slick(slider_options);

      // make sure "Same as Billing" checkbox is hidden
      $('#shipping-address-same-as-billing-label').css({"opacity":0});

      equalizeSignupHeaderHeight();
    }

    // function to initialize the positions of the Signup form progress dots
    function initializePositionSignupProgressDots() {
      const signupProgressButtonWidth = $('.signup-section__signup-progress__dots > li').outerWidth();
      const signupProgressRowPaddingRight = parseInt($('#signup-progress-container').css("paddingRight"));
      const progressRowWidth = $('#signup-progress-container').innerWidth();
      let dotPositionStart = 0;
      const arrayLength = $('.signup-section__signup-progress__dots > li').length;
      $($('.signup-section__signup-progress__dots > li').get().reverse()).each((i, e) => {


        if (i !== (arrayLength-1)) {
          $(e).css({"right": `${dotPositionStart}px`});
          dotPositionStart = dotPositionStart + signupProgressButtonWidth;
        } else {
          $(e).css({"right": `${progressRowWidth-(signupProgressButtonWidth+(signupProgressRowPaddingRight*2))}px`});
        }
      });

      // grab the progress-labels from the slides and add that info to the dot elements
      $('.signup-section__signup-progress__dots > li').each((i, e) => {
        $(e).attr('data-dot-number',(i+1));
        $(e).attr('data-label', $('.signup-section__column--signup-form-container:not([data-slick-index^="-"])').get(i).getAttribute('data-progress-title'));
      });
    }

    // function for performing the AJAX request to get Professionals' information and creating the HTML template
    function getProfessionals(url, dataObj, security, action) {
      $.ajax({
        url,
        method: 'post',
        dataType: 'json',
        data: {'json': dataObj, 'security': security, 'action': action},
        success(response, textStatus, jqXhr) {
          if (response.status === 'success') {
            const radius = parseInt( parseFloat( response.data.radius ) / 1609.34 );
            if (response.data.results > 0) {
              // Houston, we have Professional data
              let rows = ''; // for storing the HTML
              response.data.data.forEach((element, index) => {
                let connectButtonText = 'Connect';
                let connectedButtonClass = '';
                let connectButton = '';

                // make sure to remove Connect buttons if radius is greater than 25
                if (radius > 25) {
                  element.show_connect_button = false;
                }

                if (element.connected) {
                  connectButtonText = 'Saved';
                  connectedButtonClass = ' connected';
                  connectButton = `<div class="signup-section__column--epionce-near-you-connect"><a class="signup-section__epionce-near-you__connect-button${connectedButtonClass}" id="connect-button_${element.pro_code}" href="#">${connectButtonText}</a></div>`
                } else if (element.show_connect_button) {
                  connectButtonText = 'Connect';
                  connectButton = `<div class="signup-section__column--epionce-near-you-connect"><a class="signup-section__epionce-near-you__connect-button${connectedButtonClass}" id="connect-button_${element.pro_code}" href="#">${connectButtonText}</a></div>`
                } else {
                  connectButton = '<div class="signup-section__column--epionce-near-you-connect bold" style="text-align:right;"><i class="far fa-phone"></i> Call for Info</div>'
                }
                rows += `<div class="signup-section__row--epionce-near-you-result"><div class="signup-section__column--epionce-near-you-distance"><p class="signup-section__epionce-near-you__distance">${element.distance} mi.</p></div><div class="signup-section__column--epionce-near-you-pro-info"><p class="signup-section__epionce-near-you__pro-name">${element.business_name}</p><address class="signup-section__epionce-near-you__pro-address">${element.address}<br>${element.city}, ${element.state} ${element.zipcode}</address><a class="signup-section__epionce-near-you__pro-phone-number" href="tel:${element.phone_number}">${element.phone_number}</a></div>${connectButton}</div>`;
              });

              // place in the view
              $('#find-nearby-pros-container').html(rows);

            } else {
              // no results found
              let noResultsHtml;
              if ( radius === 25 ) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a id="find-nearby-pros-button" data-radius="150" href="#">click here</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              if (radius === 150) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a id="find-nearby-pros-button" data-radius="250" href="#">click here</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              if (radius === 250) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="signup-section__row--no-margin">'+
                                  '<div class="signup-section__column--search-button-container">'+
                                    '<p class="signup-section__epionce-near-you__retry-text">Thank you for your ongoing interest in Epionce! Unfortunately, there is not a physician in your area retailing Epionce at this time. Talk to your skin care professional about bringing Epionce closer to you. Please contact us to be referred to an Epionce Professional that may be near you.<br><a href="/customer-service/" style="display:inline-block;margin-top:1rem;">Contact Us</a></p>'+
                                  '</div>'+
                                '</div>';
              }

              $('#find-nearby-pros-container').html(noResultsHtml);
            }
          } else {
            console.log("AJAX was successful, return status other than success...");
            console.log(textStatus);
          }
        },
        error(jqXhr, textStatus, errorThrown) {
          console.log(jqXhr);
          console.log(textStatus);
          console.log(errorThrown);
        }
      });
    }

    // function for handler a successful location watch call
    function geo_success(position) {

      // get the acquired coordinates
      // for testing with remote location
      // var lat = 39.4381245;
      // var lng = -116.9852422;
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;



      // get the radius to use
      let radius = 25;
      if (typeof window.signupProRadius !== 'undefined' && window.signupProRadius !== null && window.signupProRadius !== '') {
        radius = window.signupProRadius;
      }

      // create the data obj to send to the server side
      const coord_obj = {
        lat,
        lng,
        radius
      };

      // perform the AJAX request to gather professionals data and build HTML professionals list template
      getProfessionals(epionce_near_you.ajaxUrl, coord_obj, epionce_near_you.nonce, 'find_professionals');
    }

    // function for handling a location watch call that has errors
    function geo_error(error) {
      let errorMessage = '';
      let primaryButtonText = '';
      let primaryButtonDataActionAttr = '';

      switch(error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = 'You have blocked this site from accessing your location.';
          primaryButtonText = 'Learn How To Unblock Location Access';
          primaryButtonDataActionAttr = 'unblock_location';
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = 'Your location information is currently unavailable. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.TIMEOUT:
          errorMessage = 'The request to get your location took too long. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.UNKNOWN_ERROR:
          errorMessage = 'An unknown error occurred while trying to access your location. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
      }

      // do something now that we know which error occurred
      const errorHtml = `<div class="signup-section__row--no-margin"><div class="<div class="signup-section__column--error-message-container"><p class="signup-section__epionce-near-you__error-message-text">${errorMessage}</p></div><div class="signup-section__column--error-button-container"><a class="signup-section__epionce-near-you__error-button" id="epionce-near-you-location-error-button" data-action="${primaryButtonDataActionAttr}" href="#">${primaryButtonText}</a></div></div>`;

      // place the location error message template
      $('#find-nearby-pros-container').html(errorHtml);
    }

    // function to locate nearby professionals
    function findNearbyProfessionals(radius) {

      window.signupProRadius = radius;

      // kill any pre-existing watchIds
      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId);
      }

      const geo_options = {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 3600000 // one hour in milliseconds
      };

      window.watchId = navigator.geolocation.watchPosition(geo_success, geo_error, geo_options);
    }

    // function to save an inputted Professional Code
    function saveProfessionalCodeToUserAccount(professionalCode, saveButtonId, proCodeFieldId) {
      // give the button a spinner
      $(`#${saveButtonId}`).html('<i class="far fa-spinner fa-pulse"></i>');

      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      // fulfilled promise with success
      $promise.done((response, textStatus, jqXhr) => {

        if (response.status === 'fail') {
          $(`#${saveButtonId}`).html('Save');
          $(`#${proCodeFieldId}`).val('');
          $(`#${proCodeFieldId}`).attr('placeholder','Enter a valid Professional Code');
          alert(response.data.proCode);

        } else if (response.status === 'success') {
          $(`#${saveButtonId}`).html('Saved!');

          setTimeout(() => {
            $(`#${proCodeFieldId}`).val('');
            $(`#${saveButtonId}`).removeClass('isVisible');

            // stagger the label change so the opacity transition has time to complete
            setTimeout(() => {
              $(`#${saveButtonId}`).html('Save');
            },250);
          },2000);
        }
      });

      // fulfilled promise with error
      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
        $(`#${saveButtonId}`).html('Error...please try again');

        setTimeout(() => {
          $(`#${saveButtonId}`).html('Save');
        },2000);
      });
    }

    // function to connect a user to a pro via Connect button click
    function saveProfessionalCodeToUserAccount_buttonClick(buttonClass, clickedConnectButtonId) {
      // get the professional code from the button id
      const professionalCodeArray = clickedConnectButtonId.split('_');
      const professionalCode = professionalCodeArray[1];

      // give the button a spinner
      $(`#${clickedConnectButtonId}`).html('<i class="far fa-spinner fa-pulse"></i>');

      // create the AJAX promise
      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      // fulfilled promise with success
      $promise.done((response, textStatus, jqXhr) => {

        if (response.status === 'fail') {
          // find all Connect buttons, remove the connected class and replace text with Connect
          $(`.${buttonClass}`).each(function(i,e){
            $(this).removeClass('connected').html('Connect');
          });
          alert(response.data.proCode);
        } else if (response.status === 'success') {
          // find all Connect buttons, remove the connected class and replace text with Connect
          $(`.${buttonClass}`).each(function(i,e){
            $(this).removeClass('connected').html('Connect');
          });

          // add the connected class to the clicked button
          $(`#${clickedConnectButtonId}`).html('Connected').addClass('connected');
        }
      });

      // fulfilled promise with error
      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
        $(`#${clickedConnectButtonId}`).html('Try Again');

        setTimeout(() => {
          $(`#${clickedConnectButtonId}`).html('Connect');
        },2000);
      });
    }

    // function to add tooltips to fields that need a small explanation about the input
    function addFieldTooltip(fieldId, message) {
      // get the field wrapper, which has position relative applied
      const $fieldWrapper = $(`#${fieldId}`).closest('div');

      // create the tooltip template
      const tooltipHtml = `<div class="signup-section__signup__tooltip"><a class="signup-section__signup__tooltip-close-button" id="tooltip-close-button" href="#" tabindex="-10"><i class="icon-custom-circle-plus-sign"></i></a><p class="signup-section__signup__tooltip-text">${message}</p></div>`;

      // add the tooltip to the DOM under the field
      $fieldWrapper.append(tooltipHtml);

      // activate the opacity of the tooltip
      setTimeout(() => {
        $fieldWrapper.find('.signup-section__signup__tooltip').addClass('active');
      },20);

      // disable the next button
      $('#next-prev-container').find('#next-arrow').prop('disabled', true).addClass('disabled');
    }

    // function to remove any tooltips from a field
    function removeFieldTooltip(fieldId) {
      const $fieldWrapper = $(`#${fieldId}`).closest('div');
      const $tooltip = $fieldWrapper.find('.signup-section__signup__tooltip');

      if ($tooltip.length) {
        // deactivate the opacity of the tooltip
        $tooltip.removeClass('active');

        // remove the tooltip
        setTimeout(() => {
          $tooltip.remove();
        },250);

        // reenable the next button
        $('#next-prev-container').find('#next-arrow').prop('disabled', false).removeClass('disabled');
      }
    }

    // debounced keyup handler for email validation
    const emailKeyupHandler = debounce(function(){
      const $emailField = $(this);
      const $fieldWrapper = $emailField.closest('.signup-section__signup__field-wrapper');
      const emailAddress = $emailField.val();
      const isValidEmail = validateEmailAddress(emailAddress);

      if (isValidEmail === true) {
        // put green border around the email field and add checkmark icon
        if (!$fieldWrapper.hasClass('valid')) {
          $fieldWrapper.removeClass('warning').addClass('valid');
          removeFieldTooltip($emailField.attr('id'));
        }
      } else if (typeof isValidEmail === 'string') {
        if (!$fieldWrapper.hasClass('warning')) {
          // put yellow warning border around email field and add yield icon
          $fieldWrapper.removeClass('valid').addClass('warning');

          // remove any existing tooltips
          removeFieldTooltip($emailField.attr('id'));

          // add warning tooltip
          addFieldTooltip($emailField.attr('id'),isValidEmail);
        }
      }
    }, 1500, false);

    // function to validate email addresses
    function validateEmailAddress(emailAddress) {
      const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      let errorMessage = true;

      // check for valid address
      if (!re.test(emailAddress)) {
        errorMessage = 'Please enter a valid email address';
      }

      return errorMessage;
    }

    // debounced keyup handler for password validation
    const passwordKeyupHandler = debounce(function(){
      const $passwordField = $(this);
      const $fieldWrapper = $passwordField.closest('.signup-section__signup__field-wrapper');
      const password = $passwordField.val();
      const isValidPassword = validatePassword(password);

      if (isValidPassword === true) {
        // put green border around the email field and add checkmark icon
        if (!$fieldWrapper.hasClass('valid')) {
          $fieldWrapper.removeClass('warning').addClass('valid');
          removeFieldTooltip($passwordField.attr('id'));
        }
      } else if (typeof isValidPassword === 'string') {
        if (!$fieldWrapper.hasClass('warning')) {
          // put yellow warning border around email field and add yield icon
          $fieldWrapper.removeClass('valid').addClass('warning');

          // remove any existing tooltips
          removeFieldTooltip($passwordField.attr('id'));

          // add warning tooltip
          addFieldTooltip($passwordField.attr('id'),isValidPassword);
        }
      }
    }, 1500, false);

    // function to validate passwords
    function validatePassword(password) {

      // initilize to true and replace with error message if needed
      let errorMessage = true;

      if (password.length < 4) {
        errorMessage = 'Please enter a password with 4 or more characters';
      }

      return errorMessage;
    }

    // debounced keyup handler for password validation
    const passwordConfirmKeyupHandler = debounce(function(){
      const $passwordConfirmField = $(this);
      const $passwordField = $('#password');
      const $fieldWrapper = $passwordConfirmField.closest('.signup-section__signup__field-wrapper');
      const passwordConfirm = $passwordConfirmField.val();
      const isValidPasswordConfirm = validatePasswordConfirm($passwordField.attr('id'), $passwordConfirmField.attr('id'));

      if (isValidPasswordConfirm === true) {
        // put green border around the email field and add checkmark icon
        if (!$fieldWrapper.hasClass('valid')) {
          $fieldWrapper.removeClass('warning').addClass('valid');
          removeFieldTooltip($passwordConfirmField.attr('id'));
        }
      } else if (typeof isValidPasswordConfirm === 'string') {
        if (!$fieldWrapper.hasClass('warning')) {
          // put yellow warning border around email field and add yield icon
          $fieldWrapper.removeClass('valid').addClass('warning');

          // remove any existing tooltips
          removeFieldTooltip($passwordConfirmField.attr('id'));

          // add warning tooltip
          addFieldTooltip($passwordConfirmField.attr('id'),isValidPasswordConfirm);
        }
      }
    }, 1500, false);

    // function to validate the password confirm field
    function validatePasswordConfirm(originalPasswordFieldId, passwordConfirmFieldId) {
      const $originalPasswordField = $(`#${originalPasswordFieldId}`);
      const originalPasswordValue = $originalPasswordField.val();

      const $passwordConfirmField = $(`#${passwordConfirmFieldId}`);
      const passwordConfirmValue = $passwordConfirmField.val();

      let errorMessage = true;

      if (originalPasswordValue !== passwordConfirmValue) {
        errorMessage = 'Password Mismatch';
        return errorMessage;
      }

      if (passwordConfirmValue < 4) {
        errorMessage = 'Please enter a password with 4 or more characters';
        return errorMessage;
      }

      return errorMessage;
    }

    // utility function to check if a value is empty
    function empty(value) {
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        return false;
      } else {
        return true;
      }
    }

    // function to do a quick validation of the form prior to final submission
    function validateSignupForm(fieldsObj, requiredFieldsArray, fieldsToPagesObj) {
      let $fieldWrapper = null;
      const isValidEmailAddress = validateEmailAddress(fieldsObj.emailAddress.val());
      const isValidPassword = validatePassword(fieldsObj.password.val());
      const isValidPasswordConfirm = validatePasswordConfirm(fieldsObj.password.attr('id'), fieldsObj.passwordConfirm.attr('id'));

      if (isValidEmailAddress !== true) {
        // get the field wrapper
        $fieldWrapper = fieldsObj.emailAddress.closest('.signup-section__signup__field-wrapper');

        // put yellow warning border around email field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // remove any existing tooltips
        removeFieldTooltip(fieldsObj.emailAddress.attr('id'));

        // add warning tooltip
        addFieldTooltip(fieldsObj.emailAddress.attr('id'),isValidEmailAddress);
        $(`.signup-section__signup-progress__dots > li:nth-child(${fieldsToPagesObj.emailAddress}) > button`).trigger('click');
        return false;
      }

      if (isValidPassword !== true) {
        // get the field wrapper
        $fieldWrapper = fieldsObj.password.closest('.signup-section__signup__field-wrapper');

        // put yellow warning border around email field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // remove any existing tooltips
        removeFieldTooltip(fieldsObj.password.attr('id'));

        // add warning tooltip
        addFieldTooltip(fieldsObj.password.attr('id'),isValidPassword);
        $(`.signup-section__signup-progress__dots > li:nth-child(${fieldsToPagesObj.password}) > button`).trigger('click');
        return false;
      }

      if (isValidPasswordConfirm !== true) {
        // get the field wrapper
        $fieldWrapper = fieldsObj.passwordConfirm.closest('.signup-section__signup__field-wrapper');

        // put yellow warning border around email field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // remove any existing tooltips
        removeFieldTooltip(fieldsObj.passwordConfirm.attr('id'));

        // add warning tooltip
        addFieldTooltip(fieldsObj.passwordConfirm.attr('id'),isValidPasswordConfirm);
        $(`.signup-section__signup-progress__dots > li:nth-child(${fieldsToPagesObj.passwordConfirm}) > button`).trigger('click');
        return false;
      }

      // make sure all required fields contain values
      for (const prop in fieldsObj) {
        if (fieldsObj.hasOwnProperty(prop)) { // an actual property to check
          if (requiredFieldsArray.includes(prop)) { // it's in the required fields array so check it
            const val = fieldsObj[prop].val();
            if (empty(val)) {
              // get the field wrapper
              $fieldWrapper = fieldsObj[prop].closest('[class^="signup-section__signup__field-wrapper"]');

              // put yellow warning border around email field and add yield icon
              $fieldWrapper.removeClass('valid').addClass('warning');

              // remove any existing tooltips
              removeFieldTooltip(fieldsObj[prop].attr('id'));

              // add warning tooltip
              addFieldTooltip(fieldsObj[prop].attr('id'),'This field is required');
              $(`.signup-section__signup-progress__dots > li[data-dot-number=${fieldsToPagesObj[prop]}] > button`).trigger('click');
              return false;
            }
          }
        }
      }

      return true;
    }

    // function to handle the signup form submission
    function submitSignupForm() {

      //create an object of fields and which page they occur on
      const fieldsToPages = {
        emailAddress: 1,
        password: 1,
        passwordConfirm: 1,
        bdayMonth: 1,
        bdayDay: 1,
        bdayYear: 1,
        subscribeToNewsletter: 1,
        billingFirstName: 2,
        billingLastName: 2,
        billingAddress1: 2,
        billingAddress2: 2,
        billingCity: 2,
        billingState: 2,
        billingZip: 2,
        billingPhoneNumber: 2,
        shippingFirstName: 3,
        shippingLastName: 3,
        shippingAddress1: 3,
        shippingAddress2: 3,
        shippingCity: 3,
        shippingState: 3,
        shippingZip: 3,
        shippingPhoneNumber: 3
      };

      // get the account creation fields
      const $emailAddress = $('#email-address');
      const $password = $('#password');
      const $passwordConfirm = $('#password-confirm');
      const $bdayMonth = $('#bday-month');
      const $bdayDay = $('#bday-day');
      const $bdayYear = $('#bday-year');
      const $subscribeToNewsletter = $('#subscribe-to-epionce-newsletter');

      // get the billing fields
      const $billingFirstName = $('#billing-first-name');
      const $billingLastName = $('#billing-last-name');
      const $billingAddress1 = $('#billing-address-1');
      const $billingAddress2 = $('#billing-address-2');
      const $billingCity = $('#billing-city');
      const $billingState = $('#billing-state');
      const $billingZip = $('#billing-zip');
      const $billingPhoneNumber = $('#billing-phone-number');

      // get the shipping fields
      const $shippingFirstName = $('#shipping-first-name');
      const $shippingLastName = $('#shipping-last-name');
      const $shippingAddress1 = $('#shipping-address-1');
      const $shippingAddress2 = $('#shipping-address-2');
      const $shippingCity = $('#shipping-city');
      const $shippingState = $('#shipping-state');
      const $shippingZip = $('#shipping-zip');
      const $shippingPhoneNumber = $('#shipping-phone-number');

      // put all of the fields in an object
      const fieldsObj = {
        emailAddress: $emailAddress,
        password: $password,
        passwordConfirm: $passwordConfirm,
        bdayMonth: $bdayMonth,
        bdayDay: $bdayDay,
        bdayYear: $bdayYear,
        subscribeToNewsletter: $subscribeToNewsletter,
        billingFirstName: $billingFirstName,
        billingLastName: $billingLastName,
        billingAddress1: $billingAddress1,
        billingAddress2: $billingAddress2,
        billingCity: $billingCity,
        billingState: $billingState,
        billingZip: $billingZip,
        billingPhoneNumber: $billingPhoneNumber,
        shippingFirstName: $shippingFirstName,
        shippingLastName: $shippingLastName,
        shippingAddress1: $shippingAddress1,
        shippingAddress2: $shippingAddress2,
        shippingCity: $shippingCity,
        shippingState: $shippingState,
        shippingZip: $shippingZip,
        shippingPhoneNumber: $shippingPhoneNumber
      };

      const requiredFieldsArray = [
        "emailAddress",
        "password",
        "passwordConfirm",
        "billingFirstName",
        "billingLastName",
        "billingAddress1",
        "billingCity",
        "billingState",
        "billingZip",
        "billingPhoneNumber",
        "shippingFirstName",
        "shippingLastName",
        "shippingAddress1",
        "shippingCity",
        "shippingState",
        "shippingZip",
        "shippingPhoneNumber"
      ];

      // one final quick validation on some common issue-prone fields
      const isValid = validateSignupForm(fieldsObj, requiredFieldsArray, fieldsToPages);

      if (isValid) {
        // perform the AJAX request to submit the form for backend validation and processing
        const json = {
          emailAddress: $emailAddress.val(),
          password: $password.val(),
          passwordConfirm: $passwordConfirm.val(),
          bdayMonth: $bdayMonth.val(),
          bdayDay: $bdayDay.val(),
          bdayYear: $bdayYear.val(),
          subscribeToNewsletter: $subscribeToNewsletter.is(':checked'),
          billingFirstName: $billingFirstName.val(),
          billingLastName: $billingLastName.val(),
          billingAddress1: $billingAddress1.val(),
          billingAddress2: $billingAddress2.val(),
          billingCity: $billingCity.val(),
          billingState: $billingState.val(),
          billingZip: $billingZip.val(),
          billingPhoneNumber: $billingPhoneNumber.val(),
          shippingFirstName: $shippingFirstName.val(),
          shippingLastName: $shippingLastName.val(),
          shippingAddress1: $shippingAddress1.val(),
          shippingAddress2: $shippingAddress2.val(),
          shippingCity: $shippingCity.val(),
          shippingState: $shippingState.val(),
          shippingZip: $shippingZip.val(),
          shippingPhoneNumber: $shippingPhoneNumber.val()
        };

        // change the button text to a spinner
        $('#next-arrow').html('<i class="far fa-spinner fa-pulse"></i>');

        // perform the AJAX request
        const $promise = $.ajax({
          url: epionce_near_you.ajaxUrl,
          method: 'post',
          dataType: 'json',
          data: {'json': json, 'security': epionce_near_you.nonce, 'action': 'validateAndSubmitSignupForm'}
        });

        $promise.done((response, textStatus, jqXhr) => {
          if (response.status === 'success') {
            $('#next-arrow').html('Success!');
            setTimeout(() => {
              $('#next-arrow').html('Redirecting...');
            },500);
            setTimeout(() => {
              const baseUrl = `${location.protocol}//${location.host}`;
              window.location.href = `${baseUrl}/products/`;
            },750);
          } else if (response.status === 'fail') {
            console.log(response);
            for (const prop in response.data) {
              console.log(prop);
              var fieldWrapper = fieldsObj[prop].parent();

              // Go back to field with error
              $(`.signup-section__signup-progress__dots > li[data-dot-number=${fieldsToPages[prop]}] > button`).trigger('click');

              // Add warning to field wrapper
              fieldWrapper.removeClass('valid').addClass('warning');

              $('.signup-section__column--form-container').css("margin-bottom", "20px");

              // Tooltip with error response
              addFieldTooltip(fieldsObj[prop].attr('id'), response.data[prop]);
            }
          }
        });

        $promise.fail((jqXhr, textStatus, errorThrown) => {
          console.log(jqXhr);
          console.log(textStatus);
          console.log(errorThrown);
        });
      }
    }





    ////////////////////
    // EVENT HANDLERS //
    ////////////////////

    // set up any window resize events
    $(window).resize(e => {
      initializePositionSignupProgressDots();
    });

    $('#show-pro-code-input').on('click', function (e) {
      e.preventDefault();
      $('#pro-code').css('display', 'inline-block');
      $(this).remove();
      $('#pro-code').focus();
      $('#connect-save-button').css('display','inline-block');
    });

    // set the click handler for the Signup Progress dots
    $('#signup-progress-container').on('click', '.signup-section__signup-progress__dots > li > button', e => {
      e.preventDefault();
      e.stopPropagation();
      console.log('clicked a dot');
      const target = $(e.target).closest('li').get(0) || $(e.srcElement).closest('li').get(0);
      const number = $(target).attr('data-dot-number');
      const signupProgressButtonWidth = $('.signup-section__signup-progress__dots > li').outerWidth();
      const signupProgressRowPaddingRight = parseInt($('#signup-progress-container').css("paddingRight"));
      const progressRowWidth = $('#signup-progress-container').innerWidth();

      // calculate how far from the left of the container to place the dot aka count the dots to the left and add their widths to the left position
      if (number == 1) {
        // the #1 button
        $(target).css({"right": `${progressRowWidth-(signupProgressButtonWidth+(signupProgressRowPaddingRight*2))}px`}).find('button').css({"paddingBottom":"8px"}).html('1');

        // the #2 button
        $(target).next().css({"right":`${signupProgressButtonWidth}px`}).find('button').css({"paddingBottom":"8px"}).html('2');

        // the #3 button
        $(target).next().next().css({"right":"0px"});

        // make sure "Same as Billing" checkbox is hidden
        $('#shipping-address-same-as-billing-label').css({"opacity":0});

        // change the label to Next just in case we've been to the third slide
        $('#next-arrow').html("Next &rsaquo;").attr('data-click-action','no_submit');

      } else if (number == 2) {
        // the #2 button
        $(target).css({"right":`${progressRowWidth-((signupProgressButtonWidth*2)+(signupProgressRowPaddingRight*2))}px`}).find('button').css({"paddingBottom":"8px"}).html('2');

        // the #1 button
        $(target).prev().find('button').html('<i class="icon-custom-checkmark"></i>').css({"paddingBottom": "0px"});

        // the #3 button
        $(target).next().css({"right":"0px"});

        // make sure "Same as Billing" checkbox is hidden
        $('#shipping-address-same-as-billing-label').css({"opacity":0});

        // change the label to Next just in case we've been to the third slide
        $('#next-arrow').html("Next &rsaquo;").attr('data-click-action','no_submit');

      } else if (number == 3) {
        // the #3 button
        $(target).css({"right":`${progressRowWidth-((signupProgressButtonWidth*3)+(signupProgressRowPaddingRight*2))}px`});

        // the #2 button
        $(target).prev().css({"right":`${progressRowWidth-((signupProgressButtonWidth*2)+(signupProgressRowPaddingRight*2))}px`}).find('button').css({"paddingBottom":"0px"}).html('<i class="icon-custom-checkmark"></i>');

        // the #1 button
        $(target).prev().prev().css({"right": `${progressRowWidth-(signupProgressButtonWidth+(signupProgressRowPaddingRight*2))}px`}).find('button').css({"paddingBottom":"0px"}).html('<i class="icon-custom-checkmark"></i>');

        // make sure "Same as Billing" checkbox is shown
        $('#shipping-address-same-as-billing-label').css({"opacity":1});

        // change the label of the next button to Finish
        // add attribute to signify that the next click would submit the form
        $('#next-arrow').html('Finish').attr('data-click-action','submit');
      }
    });

    // delegated click handler for the slider next arrow
    $('#next-prev-container').on('click','#next-arrow',e => {
      e.preventDefault();
      const target = e.target || e.srcElement;
      const $target = $(target);


      const clickAction = $target.attr('data-click-action');
      if (clickAction === 'submit') {
        submitSignupForm();
      } else {
        $('.signup-section__signup-progress__dots > li.slick-active > button').trigger('click');
      }
    });

    // delegated click handler for the slider prev arrow
    $('#next-prev-container').on('click','#prev-arrow',e => {
      e.preventDefault();
      $('.signup-section__signup-progress__dots > li.slick-active > button').trigger('click');
    });

    // click handler for the Find Nearby Professionals button in the sidebar
    $('#find-nearby-pros-container').on('click', '#find-nearby-pros-button', function(e){
      e.preventDefault();

      const $button = $(this);
      let radius = 25;
      if ($button.attr('data-radius')) {
        radius = parseInt( $button.attr('data-radius') );
      }
      $button.html('<i class="far fa-spinner fa-pulse"></i>');
      findNearbyProfessionals(radius);
    });

    // delegated click handler for the error message button
    $('#find-nearby-pros-container').on('click','#epionce-near-you-location-error-button',e => {
      e.preventDefault();

      const target = e.target || e.srcElement;
      const $target = $(target);
      const radius = 25;

      const clickAction = $target.attr('data-action');

      if (clickAction === 'try_again') {
        findNearbyProfessionals(radius);
      } else if (clickAction === 'unblock_location') {
        $('#unblockLocationAccessModal').modal({"show":true});
      }
    });

    // delegated click handler for the Connect buttons in the Find Professionals widget
    $('#find-nearby-pros-container').on('click', '.signup-section__epionce-near-you__connect-button', e => {
      e.preventDefault();

      const target = e.target || e.srcElement;

      // get the button id
      const buttonId = $(target).attr('id');

      // save the pro code to the users account or user preferences session entry
      saveProfessionalCodeToUserAccount_buttonClick('signup-section__epionce-near-you__connect-button', buttonId);
    });

    // keyup handler for the professional code entry field
    $('#pro-code').on('keyup',function(e){
      const proCode =  $(this).val();
      const $connectSaveButton = $('#connect-save-button');

      // remove any tooltips that may be attached to this field
      removeFieldTooltip($(this).attr('id'));

      if (typeof proCode !== 'undefined' && proCode !== null && proCode !== '') {
        if (!$connectSaveButton.hasClass('isVisible')) {
          $connectSaveButton.addClass('isVisible');
        }
      } else {
        $connectSaveButton.removeClass('isVisible');
      }
    });

    // click handler for the professional code entry field button
    $('#connect-save-button').on('click',e => {
      e.preventDefault();
      const $professionalCodeField = $('#pro-code');
      const professionalCode = $professionalCodeField.val();

      if ( typeof professionalCode !== 'undefined' && professionalCode !== null && professionalCode !== '' ) {
        // if it's a valid value, save it
        saveProfessionalCodeToUserAccount(professionalCode, 'connect-save-button', $professionalCodeField.attr('id'));
      } else {
        // it's an invalid value, display tooltip
        // first remove any existing tooltips
        removeFieldTooltip($professionalCodeField.attr('id'));

        // add the tooltip
        addFieldTooltip($professionalCodeField.attr('id'), 'Please enter a valid Professional Code');
      }
    });

    // add delegated event handler for tooltip close buttons
    $('.signup-section__signup__field-wrapper, .signup-section__already-connected__field-wrapper').on('click', '#tooltip-close-button', e => {
      e.preventDefault();
      e.stopPropagation();

      const target = e.target || e.srcElement;
      $target = $(target);

      const $tooltip = $target.closest('.signup-section__signup__tooltip');
      $tooltip.removeClass('active');
      setTimeout(() => {
        $tooltip.remove();
      },250);
    });

    // change handler for email field
    $('#email-address').on('change',function(e){
      const $emailField = $(this);
      const $fieldWrapper = $emailField.closest('.signup-section__signup__field-wrapper');
      const emailAddress = $emailField.val();
      const isValidEmail = validateEmailAddress(emailAddress);

      if (isValidEmail === true) {
        // put green border around the email field and add checkmark icon
        $fieldWrapper.removeClass('warning').addClass('valid');
        removeFieldTooltip($emailField.attr('id'));
      } else if (typeof isValidEmail === 'string') {
        // put yellow warning border around email field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // remove any existing tooltips
        removeFieldTooltip($emailField.attr('id'));

        // add warning tooltip
        addFieldTooltip($emailField.attr('id'),isValidEmail);
      }
    });

    // keyup handler for the email field
    $('#email-address').on('keyup', emailKeyupHandler);

    // change handler for the password field
    $('#password').on('change',function(e){
      const $passwordField = $(this);
      const $fieldWrapper = $passwordField.closest('.signup-section__signup__field-wrapper');
      const password = $passwordField.val();
      const isValid = validatePassword(password);

      if (isValid === true) {
        $fieldWrapper.removeClass('warning').addClass('valid');
        removeFieldTooltip($passwordField.attr('id'));
      } else if (typeof isValid === 'string') {
        // style input field
        // put yellow warning border around password field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // add tooltip
        removeFieldTooltip($passwordField.attr('id')); // remove any existing
        addFieldTooltip($passwordField.attr('id'), isValid);
      }
    });

    // keyup handler for the password field
    $('#password').on('keyup', passwordKeyupHandler);

    // change handler for the password confirm field
    $('#password-confirm').on('change',function(e){
      const $passwordConfirmField = $(this);
      const $fieldWrapper = $passwordConfirmField.closest('.signup-section__signup__field-wrapper');
      const password = $passwordConfirmField.val();
      const isValid = validatePasswordConfirm('password', $passwordConfirmField.attr('id'));

      if (isValid === true) {
        $fieldWrapper.removeClass('warning').addClass('valid');
        removeFieldTooltip($passwordConfirmField.attr('id'));
      } else if (typeof isValid === 'string') {
        // style input field
        // put yellow warning border around password field and add yield icon
        $fieldWrapper.removeClass('valid').addClass('warning');

        // remove any existing
        removeFieldTooltip($passwordConfirmField.attr('id'));

        // add tooltip
        addFieldTooltip($passwordConfirmField.attr('id'), isValid);
      }
    });

    // keyup handler for the password confirm field
    $('#password-confirm').on('keyup',passwordConfirmKeyupHandler);

    // loop through the remaining required fields that merely require input of any sort and attach change handlers
    const requiredFieldsArray = [
      "billingFirstName",
      "billingLastName",
      "billingAddress1",
      "billingCity",
      "billingState",
      "billingZip",
      "billingPhoneNumber",
      "shippingFirstName",
      "shippingLastName",
      "shippingAddress1",
      "shippingCity",
      "shippingState",
      "shippingZip",
      "shippingPhoneNumber"
    ];

    // get the required billing fields
    const $billingFirstName = $('#billing-first-name');
    const $billingLastName = $('#billing-last-name');
    const $billingAddress1 = $('#billing-address-1');
    const $billingCity = $('#billing-city');
    const $billingState = $('#billing-state');
    const $billingZip = $('#billing-zip');
    const $billingPhoneNumber = $('#billing-phone-number');

    // get the required shipping fields
    const $shippingFirstName = $('#shipping-first-name');
    const $shippingLastName = $('#shipping-last-name');
    const $shippingAddress1 = $('#shipping-address-1');
    const $shippingCity = $('#shipping-city');
    const $shippingState = $('#shipping-state');
    const $shippingZip = $('#shipping-zip');
    const $shippingPhoneNumber = $('#shipping-phone-number');

    // put all of the required fields in an object
    const fieldsObj = {
      billingFirstName: $billingFirstName,
      billingLastName: $billingLastName,
      billingAddress1: $billingAddress1,
      billingCity: $billingCity,
      billingState: $billingState,
      billingZip: $billingZip,
      billingPhoneNumber: $billingPhoneNumber,
      shippingFirstName: $shippingFirstName,
      shippingLastName: $shippingLastName,
      shippingAddress1: $shippingAddress1,
      shippingCity: $shippingCity,
      shippingState: $shippingState,
      shippingZip: $shippingZip,
      shippingPhoneNumber: $shippingPhoneNumber
    };

    requiredFieldsArray.forEach((fieldName, index) => {
      // change event handler
      $(`#${fieldsObj[fieldName].attr('id')}`).on('change',function(e){
        const $fieldWrapper = fieldsObj[fieldName].closest('[class^="signup-section__signup__field-wrapper"]');
        const isValid = !empty($(this).val());

        if (isValid === true) {
          $fieldWrapper.removeClass('warning').addClass('valid');
          removeFieldTooltip(fieldsObj[fieldName].attr('id'));
        } else {
          // style input field
          // put yellow warning border around password field and add yield icon
          $fieldWrapper.removeClass('valid').addClass('warning');

          // remove any existing
          removeFieldTooltip(fieldsObj[fieldName].attr('id'));

          // add tooltip
          addFieldTooltip(fieldsObj[fieldName].attr('id'), 'This field is required');
        }
      });
    });

    // change handler for the Same as Billing checkbox
    $('#shipping-address-same-as-billing').on('change',function(e){
      const isChecked = $(this).is(':checked');

      // grab all of the billing fields and put them in an object
      const billingFieldsObj = {
        billingFirstName: $('#billing-first-name'),
        billingLastName: $('#billing-last-name'),
        billingAddress1: $('#billing-address-1'),
        billingAddress2: $('#billing-address-2'),
        billingCity: $('#billing-city'),
        billingState: $('#billing-state'),
        billingZip: $('#billing-zip'),
        billingPhoneNumber: $('#billing-phone-number')
      };

      if (isChecked) {

        // grab all of billing field values and copy to shipping form
        const billingFirstName = billingFieldsObj.billingFirstName.val();
        const billingLastName = billingFieldsObj.billingLastName.val();
        const billingAddress1 = billingFieldsObj.billingAddress1.val();
        const billingAddress2 = billingFieldsObj.billingAddress2.val();
        const billingCity = billingFieldsObj.billingCity.val();
        const billingState = billingFieldsObj.billingState.val();
        const billingZip = billingFieldsObj.billingZip.val();
        const billingPhoneNumber = billingFieldsObj.billingPhoneNumber.val();

        $('#shipping-first-name').val(billingFirstName);
        $('#shipping-last-name').val(billingLastName);
        $('#shipping-address-1').val(billingAddress1);
        $('#shipping-address-2').val(billingAddress2);
        $('#shipping-city').val(billingCity);
        $('#shipping-state').val(billingState);
        $('#shipping-zip').val(billingZip);
        $('#shipping-phone-number').val(billingPhoneNumber);

        // loop through each and copy over valid and warning classes from field wrapper
        var billingFieldId = null;
        var billingFieldIdArray = null;
        var billingFieldIdBase = null;
        for (var prop in billingFieldsObj) {
          if (billingFieldsObj.hasOwnProperty(prop)) {
            var $fieldWrapper = billingFieldsObj[prop].closest('[class^="signup-section__signup__field-wrapper"]');
            if ($fieldWrapper.hasClass('valid')) {
              billingFieldId = billingFieldsObj[prop].attr('id');
              billingFieldIdArray = billingFieldId.split('billing-');
              billingFieldIdBase = billingFieldIdArray[1];
              $(`#shipping-${billingFieldIdBase}`).closest('[class^="signup-section__signup__field-wrapper"]').addClass('valid');
              removeFieldTooltip(`shipping-${billingFieldIdBase}`);
            } else if ($fieldWrapper.hasClass('warning')) {
              billingFieldId = billingFieldsObj[prop].attr('id');
              billingFieldIdArray = billingFieldId.split('billing-');
              billingFieldIdBase = billingFieldIdArray[1];
              $(`#shipping-${billingFieldIdBase}`).closest('[class^="signup-section__signup__field-wrapper"]').addClass('warning');
              addFieldTooltip(`shipping-${billingFieldIdBase}`, 'This field is required');
            }
          }
        }
      } else {
        // clear the fields in the shipping form
        $('#shipping-first-name').val('');
        $('#shipping-last-name').val('');
        $('#shipping-address-1').val('');
        $('#shipping-address-2').val('');
        $('#shipping-city').val('');
        $('#shipping-state').val('AK'); // just make it the first choice
        $('#shipping-zip').val('');
        $('#shipping-phone-number').val('');

        // loop through each and remove valid and warning classes from field wrapper
        var billingFieldId = null;
        var billingFieldIdArray = null;
        var billingFieldIdBase = null;
        for (var prop in billingFieldsObj) {
          if (billingFieldsObj.hasOwnProperty(prop)) {
            billingFieldId = billingFieldsObj[prop].attr('id');
            billingFieldIdArray = billingFieldId.split('billing-');
            billingFieldIdBase = billingFieldIdArray[1];
            $fieldWrapper = $(`#shipping-${billingFieldIdBase}`).closest('[class^="signup-section__signup__field-wrapper"]');
            $fieldWrapper.removeClass('valid warning');
            removeFieldTooltip(`shipping-${billingFieldIdBase}`);
          }
        }
      }
    });






    ////////////////////
    // INITIALIZATION //
    ////////////////////

    // set up some common resources
    // const signupSlickSliderOptions = {
    //   "dots": true,
    //   "appendDots": $('#signup-progress-container'),
    //   "dotsClass": "signup-section__signup-progress__dots",
    //   "arrows": true,
    //   "appendArrows": $('#next-prev-container'),
    //   "prevArrow": '<div class="signup-section__column--prev-arrow-container"><button class="signup-section__signup__prev-arrow" id="prev-arrow">&lsaquo; Back</button></div>',
    //   "nextArrow": '<div class="signup-section__column--next-arrow-container"><button class="signup-section__signup__next-arrow" id="next-arrow">Next &rsaquo;</button></div>',
    //   "infinite": false,
    //   "adaptiveHeight": true,
    //   "draggable": false,
    //   "touchMove": false,
    //   "speed": 250
    // };
    // initializeSlider('signup-slider', signupSlickSliderOptions);




    ////////////
    // ONLOAD //
    ////////////
    $(window).load(() => {
      // set up some common resources
      const signupSlickSliderOptions = {
        "dots": true,
        "appendDots": $('#signup-progress-container'),
        "dotsClass": "signup-section__signup-progress__dots",
        "arrows": true,
        "appendArrows": $('#next-prev-container'),
        "prevArrow": '<div class="signup-section__column--prev-arrow-container"><button class="signup-section__signup__prev-arrow" id="prev-arrow">&lsaquo; Back</button></div>',
        "nextArrow": '<div class="signup-section__column--next-arrow-container"><button class="signup-section__signup__next-arrow" id="next-arrow">Next &rsaquo;</button></div>',
        "infinite": false,
        "adaptiveHeight": true,
        "draggable": false,
        "touchMove": false,
        "speed": 250
      };
      initializeSlider('signup-slider', signupSlickSliderOptions);
      
      initializePositionSignupProgressDots();
    });
  },
  finalize() {
    // JavaScript to be fired on the Signup page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/signup.js